<template>
  <div class="row p-md-5 mx-md-3">
    <div class="col-12 mb-5">
      <div class="row mb-5">
        <div class="col-md-4 text-center">
          <div class="row">
            <div class="col-12 my-md-3 text-center">
              <h3 class="my-md-5 my-3">Escala <br/> de <br/> Preferencias</h3>
            </div>
            <div class="col-12 my-md-3 text-center">
              <h2 class="my-md-5 my-3">KUDER VOCACIONAL</h2>
            </div>
          </div>
          <div class="row d-none d-md-block">
            <div class="col-12 mt-3 text-center">
              <button class="btn btn-lg btn-primary" v-on:click="Iniciar_Examen">Iniciar <i class="fas fa-arrow-circle-right"></i></button>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item mx-3">
              <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Instrucciones</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Ejemplo</a>
            </li>
          </ul>
          <div class="tab-content mx-2" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <div class="row mt-3">
                <div class="col-12 text-center">
                  <b>Instrucciones</b>
                </div>
                <div class="col-12 mt-3">
                  A continuación encontrará una serie de 168 actividades, reunidas en grupos de tres. Usted deberá seleccionar de cada grupo cuál de las actividades le gusta más, luego deberá seleccionar cuál de las actividades le gusta menos.
                </div>
                <div class="col-12 mt-3">
                  Algunas de las actividades requieren un previo estudio y entrenamiento, usted debe considerar que ya tiene la preparación necesaria para ejercer dicha actividad. No hay respuestas correctas o incorrectas (cada persona tiene un modo de ser distinto). Por tanto, conteste con sinceridad.
                </div>
                <div class="col-12 mt-3">
                  En algunos casos le será difícil decidir qué actividad le gusta más, sin embargo, es indispensable que usted escoja entre ellas la que le gustaría más y la que le gustaría menos.
                </div>
                <div class="col-12 text-center mt-3">
                  <b>Al contestar tenga en cuenta lo siguiente</b>
                </div>
                <div class="col-12 mt-3">
                  No piense demasiado las preguntas ni emplee mucho tiempo en decidirse; debe contestar obedeciendo su primer impulso.
                </div>
                <div class="col-12 mt-3">
                  Conteste sinceramente. No señale sus respuestas pensando en lo que "es bueno" o "lo que interesa" para impresionar al examinador.
                </div>
              </div>
            </div>
            <div class="tab-pane fade px-md-4" id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <div class="row mt-3">
                <div class="col-12">
                  <b>Ejemplo:</b>
                </div>
                <div class="col-12 mt-3">
                  <b>Seleccionar respuesta:</b>
                </div>
                <div class="col-12 mt-3">
                  1. Posicione la flecha del mouse sobre la columna "Me gusta más" y presione el boton izquierdo para marcar la actividad seleccionada.
                </div>
                <div class="col-12 mt-3">
                  2. Posicione la flecha del mouse sobre la columna "Me gusta menos" y presione el boton izquierdo para marcar la actividad seleccionada
                </div>
                <div class="col-12 mt-3">
                  <b>Cancelar respuesta:</b>
                </div>
                <div class="col-12 mt-3">
                  1. Posicione la flecha del mouse en la marca de la actividad a cancelar.
                </div>
                <div class="col-12 mt-3">
                  2. Presione el boton izquierdo del mouse para quitar la marca.
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col" class="text-center">Actividad</th>
                        <th scope="col" class="text-center">Me gusta más</th>
                        <th scope="col" class="text-center">Me gusta menos</th>
                      </tr>
                    </thead>
                    <tbody v-for="pregunta of ejemplo.preguntas" v-if="pregunta.active">
                      <tr v-for="opcion of pregunta.opciones">
                        <th scope="row">{{opcion.inciso}}</th>
                        <td>{{opcion.nompregunta}}</td>
                        <td v-on:click="Seleccionar_Respuesta(pregunta.numero,opcion.inciso,0)" class="text-center">
                          <i v-if="opcion.respuesta==0" class="fas fa-check"></i>
                        </td>
                        <td v-on:click="Seleccionar_Respuesta(pregunta.numero,opcion.inciso,1)" class="text-center">
                          <i v-if="opcion.respuesta==1" class="fas fa-check"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-5 text-center d-block d-md-none">
          <button class="btn btn-lg btn-primary" v-on:click="Iniciar_Examen">Iniciar <i class="fas fa-arrow-circle-right"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      ejemplo:{
        preguntas:[
          {
            numero:1,
            active:true,
            opciones:[
              {
                inciso:'A)',
                nompregunta:'En sus viajes observar de preferencia la gente',
                respuesta:0
              },
              {
                inciso:'B)',
                nompregunta:'En sus viajes observar de preferencia los paisajes',
                respuesta:1
              },
              {
                inciso:'C)',
                nompregunta:'En sus viajes observar de preferencia los cultivos',
                respuesta:null
              },
            ]
          },
          {
            numero:2,
            active:false,
            opciones:[
              {
                inciso:'A)',
                nompregunta:'En sus viajes observar de preferencia la gente',
                respuesta:0
              },
              {
                inciso:'B)',
                nompregunta:'En sus viajes observar de preferencia los paisajes',
                respuesta:0
              },
              {
                inciso:'C)',
                nompregunta:'En sus viajes observar de preferencia los cultivos',
                respuesta:0
              },
            ]
          }
        ]
      }
    }
  },
  methods:{
    Seleccionar_Respuesta(numero_pregunta,inciso,numero){
      for (var i = 0; i < this.ejemplo.preguntas.length; i++) {
        if (this.ejemplo.preguntas[i].numero==numero_pregunta) {
          
          for (var y = 0; y < this.ejemplo.preguntas[i].opciones.length; y++) {
            if (this.ejemplo.preguntas[i].opciones[y].inciso==inciso) {
              if (this.ejemplo.preguntas[i].opciones[y].respuesta==null) {
                this.ejemplo.preguntas[i].opciones[y].respuesta=numero;
              }else{
                this.ejemplo.preguntas[i].opciones[y].respuesta=null;
              }
            }else if (this.ejemplo.preguntas[i].opciones[y].respuesta==numero) {
              
              this.ejemplo.preguntas[i].opciones[y].respuesta=null;
            }
          }
        }
      }
      
    },
    Iniciar_Examen(){
      this.$router.push({name:'kuder_v_preguntas'});
    },
  	Cargando(){
  		this.loading='';
  		this.result='d-none';
  	},
  	Listo(){
  		this.loading='d-none';
  		this.result='';
  	}
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Examenes/Kuder/Instrucciones.vue